import { Icon } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import React from 'react';
import * as S from './styled';
export const RemoveModificationButton = ({ ariaLabel, onClick }) => {
    return (React.createElement(S.Button, { type: "button", "aria-label": ariaLabel, onClick: onClick },
        React.createElement(S.RemoveIcon, null,
            React.createElement(Icon, { component: CloseIcon, height: 10 }))));
};
